var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-message-page',{attrs:{"title":"Questionario scaduto","message":"Il periodo utile per la compilazione è terminato."}})}
var staticRenderFns = []

export { render, staticRenderFns }